import { t } from "i18next";
import { useCallback } from "react";
import { ProjectRow } from "./types";

export const useRowHelpers = (selectedRows: Record<string, ProjectRow>) => {
    const isExistDevice = useCallback((): boolean => {
        if (!selectedRows || Object.values(selectedRows).length === 0) {
            return false;
        }
        return Object.values(selectedRows).some(
            (row) => row.subRows !== undefined && row.subRows.length > 0
        );
    }, [selectedRows]);

    const isDisable = useCallback((): boolean => {
        if (!selectedRows || Object.values(selectedRows).length === 0) {
            return false;
        }
        return Object.values(selectedRows).some(
            (row) =>
                row.id_boutique !== undefined && row.key_project === undefined
        );
    }, [selectedRows]);

    return { isExistDevice, isDisable };
};

export function shops(selectedRows: ProjectRow[]): string[] {
    const shopIds =
        selectedRows[0]?.subRows?.map((row) => row.id_boutique ?? "") ?? [];
    return [...new Set(shopIds), "0"];
}

export function shopsPos(selectedRows: ProjectRow): string[] {
    const shopIds =
        selectedRows.subRows?.map((row) => row.id_boutique ?? "") ?? [];
    return [...new Set(shopIds), "0"];
}

export function isDisable(selectedRows: Record<string, ProjectRow>): boolean {
    if (!selectedRows || Object.values(selectedRows).length === 0) {
        return false;
    }
    return Object.values(selectedRows).some(
        (row) => (row as Record<string, unknown>)[t("Application")] !== ""
    );
}
